module.exports = __webpack_public_path__ + "img/figure-22.180f3a03.png";